import {
  Drawer,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton
} from '@mui/material';
import {
  Menu,
  Login,
  Logout,
  Book,
  Settings,
  BarChart,
  Apps,
  Addchart,
  AddTask
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useAuthContext } from 'src/auth/hooks';

export function MenuDrawer() {
  const { isAuthenticated } = useAuthContext();
  const [open, setOpen] = useState(false);

  const loginToggle = () => {
    if (isAuthenticated) {
      return { name: 'Logout', icon: <Logout />, path: '/auth/logout' };
    }
    return { name: 'Login', icon: <Login />, path: '/auth/login' };
  };

  const data = [
    { name: 'Dashboard', icon: <Apps />, path: '/dashboard' },
    { name: 'Homework', icon: <AddTask />, path: '/homework' },
    { name: 'Compulsion Tracker', icon: <Book />, path: '/ban-book' },
    // {
    //   name: 'Accommodation Tracker',
    //   icon: <Book />,
    //   path: '/accommodation-tracker'
    // },
    { name: 'Anxiety Survey', icon: <Addchart />, path: '/anxiety-survey' },
    { name: 'Reports', icon: <BarChart />, path: '/reports' },
    { name: 'Profile', icon: <Settings />, path: '/profile' },

    loginToggle()
  ];

  const getList = () => (
    <div
      role="button"
      style={{ width: 250 }}
      onClick={() => setOpen(false)}
      onKeyUp={() => setOpen(false)}
    >
      {data.map((item) => (
        <Link to={item.path} key={item.name}>
          <ListItem button>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.name} />
          </ListItem>
        </Link>
      ))}
    </div>
  );
  return (
    <div>
      <IconButton onClick={() => setOpen(true)} aria-label="menu">
        <Menu style={{ fontSize: 50 }} />
      </IconButton>
      <Drawer open={open} anchor="right" onClose={() => setOpen(false)}>
        {getList()}
      </Drawer>
    </div>
  );
}
